import React from 'react';

const Home = () => {
    return ( 
        <>INICIO</>
     );
}
 
export default Home;